"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBanner = void 0;
// Vendors
const react_1 = require("react");
// Repository
const features_1 = require("../../features");
const useBanner = (bannerConfig) => {
    const [bannerData, setBannerData] = (0, react_1.useState)({});
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [hasError, setHasError] = (0, react_1.useState)(false);
    const { tracker } = bannerConfig;
    function trackBannerView(data) {
        tracker?.track(features_1.BannerTrackingActions.LATERAL_BANNER_VIEW, { title: data.title, feedback: data.feedback });
    }
    function getBannerData() {
        return (0, features_1.fetchBanner)(bannerConfig)
            .then(data => {
            setBannerData(data);
            trackBannerView(data);
        })
            .catch(() => setHasError(true))
            .finally(() => setIsLoading(false));
    }
    const onButtonClick = () => {
        tracker?.track(features_1.BannerTrackingActions.LATERAL_BANNER_CLICK_BUTTON, { title: bannerData.title, feedback: bannerData.feedback });
    };
    (0, react_1.useEffect)(() => {
        getBannerData();
    }, []);
    return {
        bannerData,
        isLoading,
        hasError,
        onButtonClick,
    };
};
exports.useBanner = useBanner;
exports.default = exports.useBanner;
//# sourceMappingURL=useBanner.hook.js.map